import React, { useState } from "react";
import { Lock, User, ShieldCheck, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      if (res.ok) {
        const d = await res.json();
        onLogin(d.token, d.expires_in);
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      setError("Could not reach the server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0B0C] px-4" style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-3 h-9 bg-[#D32F2F]" />
          <div className="text-white">
            <div className="text-lg font-extrabold tracking-tight leading-none">REDLINE</div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-white/50">Admin Console</div>
          </div>
        </div>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="bg-[#141416] border border-white/10 rounded-2xl p-8 shadow-2xl"
        >
          <div className="flex items-center gap-2 text-white/80 mb-6">
            <ShieldCheck className="w-5 h-5 text-[#D32F2F]" />
            <h1 className="text-base font-semibold">Sign in to continue</h1>
          </div>

          <label className="block text-xs uppercase tracking-wider text-white/40 mb-2">Username</label>
          <div className="relative mb-5">
            <User className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
            <input
              data-testid="admin-username-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full bg-[#0B0B0C] border border-white/10 rounded-lg pl-9 pr-3 py-2.5 text-white text-sm focus:border-[#D32F2F] focus:outline-none transition-colors"
              placeholder="admin"
              autoFocus
            />
          </div>

          <label className="block text-xs uppercase tracking-wider text-white/40 mb-2">Password</label>
          <div className="relative mb-6">
            <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#0B0B0C] border border-white/10 rounded-lg pl-9 pr-3 py-2.5 text-white text-sm focus:border-[#D32F2F] focus:outline-none transition-colors"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div data-testid="admin-login-error" className="text-[#ff6b6b] text-sm mb-4">{error}</div>
          )}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#D32F2F] hover:bg-[#b71c1c] text-white font-semibold py-2.5 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <p className="text-center text-white/30 text-xs mt-6">Redline Monitoring Services Inc. · Internal use only</p>
      </div>
    </div>
  );
}
